import {
  setDisplayErrorSnackBar,
  // setIsLoading,
} from "../../../../features/userSlice";
import store from "../../../../store";
import {
  setEndDate,
  setSelectedAll,
  setSelectedDaysLeftForPeriod,
  setselectedDimensione,
  setSelectedInterval,
  setSelectedPriode,
  setSelectedSharedUidBui,
  setSelectedType,
  setStartDate,
  setWebsites,
} from "../../../../features/businessLeaderDashboardSlice";
import { buiDashboardService } from "../../../../services/api/bui-dashboard.endpoints";

async function getBuiDashboardData(
  oauthTokenHeader: string,
  website_shared_uid: string[],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: string[],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any,
  inerval?: any,
  daysLeft?: any
) {
  try {
    if (!startDate && !endDate) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        store.dispatch(setSelectedSharedUidBui(website_shared_uid));
        store.dispatch(setselectedDimensione(dimensions));
        store.dispatch(setSelectedType(type));
        store.dispatch(setSelectedPriode(periodType));
        store.dispatch(setSelectedInterval(inerval));
        store.dispatch(setSelectedDaysLeftForPeriod(daysLeft));
        store.dispatch(setStartDate(startDate));
        store.dispatch(setEndDate(endDate));
        store.dispatch(setSelectedAll(selectedAll));
        setData(response?.data?.data);
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_lastMonthTarget(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_last7Days(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_brandPerformance(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      //store.dispatch(setIsLoading(true));
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
        // store.dispatch(setIsLoading(false));
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_brandPerformance_lastDataRetrieval(
  oauthTokenHeader: string,
  website_shared_uid: [],
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      //      store.dispatch(setIsLoading(true));
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        "5656281524207616",
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data?.query_output);
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_loadedFromTotal(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate: any,
  endDate: any,
  actionType: string
) {
  try {
    if (!startDate && !endDate) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      const response =
        await buiDashboardService.getBuiDashboardData_loadedFromTotal(
          oauthTokenHeader,
          website_shared_uid,
          queryId,
          dimensions,
          type,
          selectedAll,
          startDate,
          endDate,
          actionType
        );
      if (!response?.data || !response?.status || response?.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_topKeyWord(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      //   store.dispatch(setIsLoading(true));
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
        //   store.dispatch(setIsLoading(false));
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_conversionLoading(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_mtdQftd(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getBuiDashboardData_sitePerformance(
  oauthTokenHeader: string,
  website_shared_uid: [],
  queryId: string,
  trackPromise: any,
  setData: any,
  dimensions: [],
  type: string,
  selectedAll: boolean,
  startDate?: any,
  endDate?: any,
  periodType?: any
) {
  try {
    if (!startDate && !endDate && !periodType) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting Business dashboard data",
            type: "error",
          })
        )
      );
    } else {
      // store.dispatch(setIsLoading(true));
      const response = await buiDashboardService.getBuiDashboardData(
        oauthTokenHeader,
        website_shared_uid,
        queryId,
        dimensions,
        type,
        selectedAll,
        startDate,
        endDate,
        periodType
      );
      if (!response || !response.status || response.status !== 200) {
        trackPromise(
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                "Something went wrong while getting Business dashboard data",
              type: "error",
            })
          )
        );
      } else {
        setData(response?.data?.data);
        // store.dispatch(setIsLoading(false));
      }
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getAllDimesnionsForViewOrganizationalSummary(
  oauthTokenHeader: string,
  trackPromise: any,
  setViewOrganizationalSummary: any
) {
  try {
    // store.dispatch(setIsLoading(true));
    const response =
      await buiDashboardService.getAllDimesnionsForViewOrganizationalSummary(
        oauthTokenHeader
      );
    if (!response || !response.status || response.status !== 200) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message:
              "Something went wrong while getting View Organizational Summary",
            type: "error",
          })
        )
      );
    } else {
      setViewOrganizationalSummary(response?.data?.data);
      // store.dispatch(setIsLoading(false));
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}
async function getWebsitesInBuiDashboard(oauthTokenHeader: string) {
  try {
    const response = await buiDashboardService.getWebsitesInBuiDashboard(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      const websitesData = response?.data?.data || [];
      store.dispatch(setWebsites(websitesData));
      return websitesData;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
export const buiDashboardEndPointLogic = {
  getBuiDashboardData,
  getBuiDashboardData_lastMonthTarget,
  getBuiDashboardData_last7Days,
  getBuiDashboardData_brandPerformance,
  getBuiDashboardData_topKeyWord,
  getBuiDashboardData_conversionLoading,
  getBuiDashboardData_mtdQftd,
  getBuiDashboardData_sitePerformance,
  getAllDimesnionsForViewOrganizationalSummary,
  getBuiDashboardData_loadedFromTotal,
  getBuiDashboardData_brandPerformance_lastDataRetrieval,
  getWebsitesInBuiDashboard,
};
